export default __webpack_public_path__ + "static/media/15.ab2f1d5c.jpg";